/*
 * @providesModule NativeContactsManager
 *
 */

const NativeContactsManager = {
  getUserContactName: (username: string) => username,
};

export default NativeContactsManager;
